import React from 'react';
import {usePromiseTracker} from "react-promise-tracker";
import {SquareLoadingSkeleton} from "../DommusLoadingSkeleton/SquareLoadingSkeleton"

export default function DommusLoadingSquare({area, children}) {
	const {promiseInProgress} = usePromiseTracker({area: area});

	return (
		promiseInProgress ?
          <SquareLoadingSkeleton/>
        : children
	);
}
